<template>
  <v-container fluid>
    <Navbar />
    <router-view></router-view>
  </v-container>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/Navbar'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    Navbar,
  },
  computed: {
    ...mapGetters([
      'isAdminUser', 
      'accessToken',
      'freshLogin'
    ]),
  },
  created() {
    if (process.env.NODE_ENV === 'production') {
      if (!this.freshLogin) {
        axios.post('auth/verify_token/', {token:this.accessToken})
        .then(resp =>{
          console.log('token validated')
        })
        .catch(err => {
          console.log('token expired')
          this.$store
            .dispatch('logout')
            .then(() => this.$router.push('/login'))
            .catch(err => console.log(err));
        })
      }
    }
  }
}
</script>
